// Get Faq
export const GET_FAQ_REQUEST = 'GET_FAQ_REQUEST';
export const GET_FAQ_DONE = 'GET_FAQ_DONE';
export const GET_FAQ_FAILED = 'GET_FAQ_FAILED';

// Get Definitions
export const GET_DEFINITIONS_REQUEST = 'GET_DEFINITIONS_REQUEST';
export const GET_DEFINITIONS_DONE = 'GET_DEFINITIONS_DONE';
export const GET_DEFINITIONS_FAILED = 'GET_DEFINITIONS_FAILED';